// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { initializeAppCheck, ReCaptchaV3Provider, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC-Hd-bhlmBTaNPpASprfe2YxEIbz_as3A",
  authDomain: "vortex-c9404.firebaseapp.com",
  databaseURL: "https://exani.firebaseio.com",
  projectId: "vortex-c9404",
  storageBucket: "vortex-c9404.firebasestorage.app",
  messagingSenderId: "986028341879",
  appId: "1:986028341879:web:baac7e063c585b65f31f3e",
  measurementId: "G-HXHTG38JQF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics conditionally (only in production)
let analytics = null;
try {
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.PROD) {
    analytics = getAnalytics(app);
  }
} catch (error) {
  // Silent catch for analytics
}

const auth = getAuth(app);
const db = getFirestore(app);
const database = getDatabase(app);

// App Check — Deshabilitado temporalmente. Para activarlo:
// 1. Habilita reCAPTCHA Enterprise API en Google Cloud Console
// 2. Registra la clave en Firebase Console > App Check > reCAPTCHA Enterprise
const enableAppCheck = false;
if (enableAppCheck) {
  try {
    const provider = import.meta.env?.VITE_RECAPTCHA_ENTERPRISE === 'true'
      ? new ReCaptchaEnterpriseProvider()
      : new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_SITE_KEY || '');
    initializeAppCheck(app, {
      provider,
      isTokenAutoRefreshEnabled: true,
    });
  } catch (appCheckErr) {
    console.warn('⚠️ No se pudo inicializar App Check:', appCheckErr);
  }
}

export { app, analytics, auth, db, database };